"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectStackedLayout = exports.default = void 0;

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _remarkStripMarkdown = _interopRequireDefault(require("../Utils/remarkStripMarkdown"));

var _Avatar = _interopRequireDefault(require("./Avatar"));

var _Bubble = _interopRequireDefault(require("./Bubble"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _SendStatus = _interopRequireDefault(require("./SendStatus"));

var _textFormatToContentType = _interopRequireDefault(require("../Utils/textFormatToContentType"));

var _Timestamp = _interopRequireDefault(require("./Timestamp"));

var _useAvatarForBot3 = _interopRequireDefault(require("../hooks/useAvatarForBot"));

var _useAvatarForUser3 = _interopRequireDefault(require("../hooks/useAvatarForUser"));

var _useLocalize = _interopRequireDefault(require("../hooks/useLocalize"));

var _useLocalizeDate = _interopRequireDefault(require("../hooks/useLocalizeDate"));

var _useStyleOptions3 = _interopRequireDefault(require("../hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var _Constants$ActivityCl = _botframeworkWebchatCore.Constants.ActivityClientState,
    SENDING = _Constants$ActivityCl.SENDING,
    SEND_FAILED = _Constants$ActivityCl.SEND_FAILED;
var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  '& > .avatar': {
    flexShrink: 0
  },
  '& > .content': {
    flexGrow: 1,
    overflow: 'hidden',
    '& > .webchat__row': {
      display: 'flex',
      '& > .bubble, & > .timestamp': {
        flexGrow: 1,
        overflow: 'hidden'
      },
      '& > .filler': {
        flexGrow: 10000,
        flexShrink: 1
      }
    }
  },
  '& > .filler': {
    flexShrink: 0
  },
  '&.from-user': {
    flexDirection: 'row-reverse',
    '& > .content > .webchat__row': {
      flexDirection: 'row-reverse'
    }
  }
});

var connectStackedLayout = function connectStackedLayout() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var language = _ref.language,
        _ref$styleSet$options = _ref.styleSet.options,
        botAvatarInitials = _ref$styleSet$options.botAvatarInitials,
        userAvatarInitials = _ref$styleSet$options.userAvatarInitials;
    var _ref2$activity = _ref2.activity;
    _ref2$activity = _ref2$activity === void 0 ? {} : _ref2$activity;
    var _ref2$activity$from = _ref2$activity.from;
    _ref2$activity$from = _ref2$activity$from === void 0 ? {} : _ref2$activity$from;
    var role = _ref2$activity$from.role;
    return {
      avatarInitials: role === 'user' ? userAvatarInitials : botAvatarInitials,
      language: language,
      // TODO: [P4] We want to deprecate botAvatarInitials/userAvatarInitials because they are not as helpful as avatarInitials
      botAvatarInitials: botAvatarInitials,
      userAvatarInitials: userAvatarInitials
    };
  }].concat(selectors));
};

exports.connectStackedLayout = connectStackedLayout;

var StackedLayout = function StackedLayout(_ref3) {
  var activity = _ref3.activity,
      children = _ref3.children,
      timestampClassName = _ref3.timestampClassName;

  var _useAvatarForBot = (0, _useAvatarForBot3.default)(),
      _useAvatarForBot2 = _slicedToArray(_useAvatarForBot, 1),
      botInitials = _useAvatarForBot2[0].initials;

  var _useAvatarForUser = (0, _useAvatarForUser3.default)(),
      _useAvatarForUser2 = _slicedToArray(_useAvatarForUser, 1),
      userInitials = _useAvatarForUser2[0].initials;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      _useStyleOptions2$ = _useStyleOptions2[0],
      botAvatarInitials = _useStyleOptions2$.botAvatarInitials,
      bubbleNubSize = _useStyleOptions2$.bubbleNubSize,
      bubbleFromUserNubSize = _useStyleOptions2$.bubbleFromUserNubSize,
      userAvatarInitials = _useStyleOptions2$.userAvatarInitials;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      stackedLayoutStyleSet = _useStyleSet2[0].stackedLayout;

  var _activity$attachments = activity.attachments,
      attachments = _activity$attachments === void 0 ? [] : _activity$attachments,
      _activity$channelData = activity.channelData;
  _activity$channelData = _activity$channelData === void 0 ? {} : _activity$channelData;
  var _activity$channelData2 = _activity$channelData.messageBack;
  _activity$channelData2 = _activity$channelData2 === void 0 ? {} : _activity$channelData2;
  var messageBackDisplayText = _activity$channelData2.displayText,
      state = _activity$channelData.state,
      _activity$from = activity.from;
  _activity$from = _activity$from === void 0 ? {} : _activity$from;
  var role = _activity$from.role,
      text = activity.text,
      textFormat = activity.textFormat,
      timestamp = activity.timestamp;
  var activityDisplayText = messageBackDisplayText || text;
  var fromUser = role === 'user';
  var initials = fromUser ? userInitials : botInitials;
  var showSendStatus = state === SENDING || state === SEND_FAILED;
  var plainText = (0, _remarkStripMarkdown.default)(text);
  var indented = fromUser ? bubbleFromUserNubSize : bubbleNubSize;
  var botRoleLabel = (0, _useLocalize.default)('BotSent');
  var userRoleLabel = (0, _useLocalize.default)('UserSent');
  var roleLabel = fromUser ? botRoleLabel : userRoleLabel;
  var botAriaLabel = (0, _useLocalize.default)('Bot said something', initials, plainText);
  var userAriaLabel = (0, _useLocalize.default)('User said something', initials, plainText);
  var sentAtTimestamp = (0, _useLocalize.default)('SentAt') + (0, _useLocalizeDate.default)(timestamp);
  var someoneSaidString = (fromUser ? userAriaLabel : botAriaLabel).trim();
  var ariaLabel = someoneSaidString + (someoneSaidString.endsWith('.') ? '' : '.') + ' ' + sentAtTimestamp;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(ROOT_CSS + '', stackedLayoutStyleSet + '', {
      'from-user': fromUser,
      webchat__stacked_extra_left_indent: fromUser && !botAvatarInitials && bubbleNubSize,
      webchat__stacked_extra_right_indent: !fromUser && !userAvatarInitials && bubbleFromUserNubSize,
      webchat__stacked_indented_content: initials && !indented
    })
  }, !initials && !!(fromUser ? bubbleFromUserNubSize : bubbleNubSize) && _react.default.createElement("div", {
    className: "avatar"
  }), _react.default.createElement(_Avatar.default, {
    "aria-hidden": true,
    className: "avatar",
    fromUser: fromUser
  }), _react.default.createElement("div", {
    className: "content"
  }, !!activityDisplayText && _react.default.createElement("div", {
    className: "webchat__row message"
  }, _react.default.createElement(_ScreenReaderText.default, {
    text: ariaLabel
  }), _react.default.createElement(_Bubble.default, {
    "aria-hidden": true,
    className: "bubble",
    fromUser: fromUser,
    nub: true
  }, children({
    activity: activity,
    attachment: {
      content: activityDisplayText,
      contentType: (0, _textFormatToContentType.default)(textFormat)
    }
  })), _react.default.createElement("div", {
    className: "filler"
  })), attachments.map(function (attachment, index) {
    return (// Because of differences in browser implementations, aria-label=" " is used to make the screen reader not repeat the same text multiple times in Chrome v75 and Edge 44
      _react.default.createElement("div", {
        "aria-label": " ",
        className: (0, _classnames.default)('webchat__row attachment', {
          webchat__stacked_item_indented: indented
        }),
        key: index
      }, _react.default.createElement(_ScreenReaderText.default, {
        text: roleLabel
      }), _react.default.createElement(_Bubble.default, {
        className: "attachment bubble",
        fromUser: fromUser,
        key: index,
        nub: false
      }, children({
        attachment: attachment
      })))
    );
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)('webchat__row', {
      webchat__stacked_item_indented: indented
    })
  }, showSendStatus ? _react.default.createElement(_SendStatus.default, {
    activity: activity,
    className: "timestamp"
  }) : _react.default.createElement(_Timestamp.default, {
    activity: activity,
    "aria-hidden": true,
    className: (0, _classnames.default)('timestamp', timestampClassName)
  }), _react.default.createElement("div", {
    className: "filler"
  }))), _react.default.createElement("div", {
    className: "filler"
  }));
};

StackedLayout.defaultProps = {
  children: undefined,
  timestampClassName: ''
};
StackedLayout.propTypes = {
  activity: _propTypes.default.shape({
    attachments: _propTypes.default.array,
    channelData: _propTypes.default.shape({
      messageBack: _propTypes.default.shape({
        displayText: _propTypes.default.string
      })
    }),
    from: _propTypes.default.shape({
      role: _propTypes.default.string.isRequired
    }).isRequired,
    text: _propTypes.default.string,
    textFormat: _propTypes.default.string,
    timestamp: _propTypes.default.string,
    type: _propTypes.default.string.isRequired
  }).isRequired,
  children: _propTypes.default.any,
  timestampClassName: _propTypes.default.string
};
var _default = StackedLayout;
exports.default = _default;